import { gql } from '@apollo/client';

export const changePasswordQuery = gql`
  mutation changePassword($newPassword: String!, $currentPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;
